import React from "react";
import { useForm, yupResolver } from "@mantine/form";
import { Button, Group, Modal, Text, Space, TextInput } from "@mantine/core";

import Colors from "../../../themes/Colors";
import { CreateLeaveExport } from "../service/model/LeaveExport";
import ExportValidationSchema from "../service/validator/ExportValidationSchema";

type ExportLeaveModalProps = {
  isOpen: boolean;
  values?: CreateLeaveExport;
  setOpen: (isOpen: boolean) => void;
  startExport: (jobName?: string) => void;
  lang: {
    title: string;
    export: string;
    cancel: string;
    jobName: string;
  };
};

const ExportLeaveModal: React.FC<ExportLeaveModalProps> = ({
  lang,
  isOpen,
  setOpen,
  values,
  startExport,
}) => {
  const form = useForm({
    schema: yupResolver(ExportValidationSchema),
    initialValues: {
      jobName: values?.jobName ?? "",
    },
  });

  const onSubmitHandler = (formValues: typeof form.values): void => {
    // Call the startExport function with the job name
    startExport(formValues.jobName);
    // Reset the form values after submission
    form.reset();
    // Close the modal
    setOpen(false);
  };

  return (
    <form
      id="export-leave-form"
      onSubmit={form.onSubmit((formValues) => onSubmitHandler(formValues))}
      style={{ width: "100%" }}
    >
      <Modal
        opened={isOpen}
        onClose={() => {
          setOpen(false);
        }}
        centered
        size="lg"
        withCloseButton={false}
        closeOnClickOutside={false}
      >
        <div>
          <Text
            size="xl"
            style={{
              fontSize: "18px",
              fontWeight: 700,
              lineHeight: "24.59px",
            }}
          >
            {lang.title}
          </Text>
          <Space h="md" />
          <div>
            <TextInput
              required
              id="jobName"
              label="Export batch name"
              value={form.values.jobName ?? null}
              onChange={(event) =>
                form.setFieldValue("jobName", event.currentTarget.value)
              }
              error={form.errors.jobName}
              maxLength={100}
            />
            {!form.errors.jobName && (
              <Text
                color={
                  form.values.jobName.length !== 100
                    ? Colors.description.primary
                    : Colors.description.error
                }
                style={{
                  width: "auto",
                  float: "right",
                  fontSize: "12px",
                }}
              >
                {form.values.jobName.length}/100 characters
              </Text>
            )}
          </div>
          <Space h="xl" />
          <Group spacing="xl" mt={16} position="right">
            <Button
              variant="outline"
              style={{
                height: "40px",
                padding: "0 20px",
                width: "150px",
              }}
              onClick={() => setOpen(false)}
            >
              {lang.cancel}
            </Button>

            <Button
              type="submit"
              form="export-leave-form"
              style={{
                height: "40px",
                padding: "0 20px",
                width: "150px",
              }}
            >
              {lang.export}
            </Button>
          </Group>
        </div>
      </Modal>
    </form>
  );
};

export default ExportLeaveModal;
